module.exports = __webpack_public_path__ + "assets/MARK_-_Technology.39ad959d.svg";